import { ga } from 'js/analytics/adapters'

export const trackViewFaq = () => {
  ga.track('View FAQ')
}
